export default {
  name: 'NewsView',
  props: {
    id: {
      type: Number,
      default: null
    }
  },
  data () {
    return {
      isMounted: null,
      isLoading: false,
      currentReq: null,
      article: null
    }
  },
  methods: {
    getArticle () {
      this.isLoading = false;
      if (this.currentReq) {
        this.currentReq.cancel('changed search query');
      }
      this.isLoading = true;
      this.$forceUpdate();
      this.currentReq = this.ApiRequest.request('news/' + this.$route.params.id, this.ApiRequest.REQUEST_GET, [], (response) => {
        if (response.data) {
          this.article = response.data;
          this.isLoading = false;
        }
      });
    }
  },
  mounted () {
    this.getArticle();
    this.isMounted = true;
  }
}
